import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { Dispatch } from "redux";
import { IVDMAlert } from "redux/app/vdmdashboard/@types";
import vdmDashboardActions from "redux/app/vdmdashboard/actions";
import { IStore } from "redux/store";

type OwnProps = {
	smartAlerts?: IVDMAlert[];
};
type AlertsSidebarHeaderProps = PropsFromRedux & OwnProps;
function AlertsSidebarHeader(props: AlertsSidebarHeaderProps) {
	const { smartAlerts } = props;
	return (
		<div className="flex items-center justify-between p-4 border-b border-gray-200">
			<h2 className="text-lg font-medium text-gray-800 flex items-center">
				<span className="bp3-icon bp3-icon-warning-sign text-lg text-gray-700 mr-2"></span>
				<span>Smart Alerts</span>
				<span className="inline-block p-0.5 px-1 bg-red-500 text-red-100 ml-2 text-xs rounded">
					{smartAlerts?.length?.toString()?.padStart(2, "0")}
				</span>
			</h2>

			<button
				type="button"
				onClick={() => {
					props.toggleAlertsSidebar(false);
				}}
				aria-label="Close drawer"
				className="text-gray-500 hover:text-gray-700"
			>
				<span className="bp3-icon bp3-icon-double-chevron-right" />
			</button>
		</div>
	);
}
function mapStateToProps(store: IStore, ownProps: OwnProps) {
	return {};
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
	return {
		toggleAlertsSidebar(isAlertsSidebarExpanded: boolean) {
			return dispatch(
				vdmDashboardActions.document.vdmDashboardAlertsToggle(
					isAlertsSidebarExpanded
				)
			);
		},
	};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(AlertsSidebarHeader);
